<template>
  <div class="work-detail">
    <Breadcrumb :breadcrumb="breadcrumb" />
    <div class="wrap max-width">
      <div class="header">
        <div class="header-title">{{ info.name }}</div>
        <SliderList class="slider-list" :items="items" @click="showDialog" />
      </div>
      <div class="middle">
        <img v-if="info.infoUrl" :src="info.infoUrl" alt="" />
      </div>
      <div class="bottom">
        <div class="bottom-title">{{ info.name }}</div>
        <el-row class="flex">
          <el-col v-for="(item, index) in items" :key="index" class="flex-item" :span="8" @click.native="showDialog(item.achievementUrl, item.companyName)">{{
            item.companyName
          }}</el-col>
        </el-row>
      </div>
    </div>
    <zwDialog v-if="visible" :visible.sync="visible" :title="title" :url="url" />
  </div>
</template>

<script>
import Breadcrumb from '@/components/Breadcrumb'
import SliderList from './SliderList.vue'
import zwDialog from './zwDialog.vue'
export default {
  components: { Breadcrumb, SliderList, zwDialog },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.breadcrumb = [
        {
          path: '/',
          name: '首页',
          meta: {
            title: '首页',
          },
        },
        {
          path: '/work/list',
          name: '成果展列表',
          meta: {
            title: '成果展列表',
          },
        },
        {
          path: `/product/detial`,
          name: '成果展详情',
          meta: {
            title: '成果展详情',
          },
        },
      ]
    })
  },
  data() {
    return {
      visible: false,
      url: '',
      info: {},
      breadcrumb: [],
      items: [],
      title: '',
    }
  },
  mounted() {
    this.queryDetail(this.$route.query.id)
    this.$nextTick(() => {
      window.scrollTo(0, 0)
    })
  },
  methods: {
    showDialog(url, title) {
      this.title = title
      this.url = url.split(',').filter(Boolean)
      this.visible = true
    },
    queryDetail(id) {
      this.$http({ method: 'get', url: '/zzmh/api/showcase/info/' + id }).then((res) => {
        this.info = res.data
        let query = this.$query.new()
        this.$query.toF(query, { showcaseId: id })
        let params = {}
        this.$http({ method: 'get', url: '/zzmh/api/achievement/list?query=' + encodeURIComponent(this.$query.toJsonStr(query)), params }).then((res) => {
          console.log(res)
          this.items = res.data.list
        })
      })
    },
  },
}
</script>

<style lang="less" scoped>
.work-detail {
  .flex {
    color: #333;
    // margin: 0 94px;
    background: url(../.././assets/images/bottom.png);
    background-size: 100% 100%;
    background-repeat: no-repeat;
    padding: 0 40px;
    min-height: 544px;
    overflow: auto;
    .flex-item {
      font-family: PingFangSC-Medium;
      font-size: 20px;
      color: #333333;
      letter-spacing: 0;
      padding: 0 20px;
      text-align: left;
      font-weight: 500;
      margin-bottom: 20px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      cursor: pointer;
      &:hover {
        color: #ff7327;
      }
    }
  }
}
.wrap {
  display: flex;
  flex-direction: column;
  .header {
    position: relative;
    width: 100%;
    height: 600px;
    background: url(../.././assets/images/header.png);
    background-size: 100% 100%;
    .header-title {
      position: absolute;
      left: 35px;
      top: 250px;
      font-family: PingFangSC-Semibold;
      font-size: 29px;
      color: #ffffff;
      letter-spacing: 2.5px;
      text-align: center;
      text-shadow: 0 2px 4px rgba(0, 0, 0, 0.5);
      font-weight: 600;
    }
    .slider-list {
      position: absolute;
      bottom: 48px;
      left: 48px;
    }
  }
  .middle {
    width: 100%;
    img {
      width: 100%;
    }
  }
  .bottom {
    width: 100%;
    // height: 600px;
    background: #fff;
    .bottom-title {
      font-family: PingFangSC-Semibold;
      font-size: 24px;
      color: #333333;
      letter-spacing: 0;
      text-align: center;
      font-weight: 600;
      margin-bottom: 50px;
      margin-top: 60px;
    }
  }
}
</style>
